export const LAST_ACTIVE_CAMPAIGN_KEY = 'lastActiveCampaignId';

export const persistActiveCampaignForReturn = (campaignId) => {
  const normalized = campaignId ? String(campaignId).trim() : '';

  if (!normalized) {
    return;
  }

  try {
    localStorage.setItem(LAST_ACTIVE_CAMPAIGN_KEY, normalized);
  } catch {
    // noop
  }
};
